"use strict";
exports.__esModule = true;
exports.FLEX_ANYWHERE_HOW_FLEX_WORKS_CONTENT = void 0;
exports.FLEX_ANYWHERE_HOW_FLEX_WORKS_CONTENT = {
    DEFAULT_BULLETS: [
        {
            HEADER: 'Get ready',
            BODY: 'When you’re ready to pay your rent, confirm the amount of your rent bill in the Flex app.'
        },
        {
            HEADER: '1st payment',
            BODY: 'Make your 1st payment to activate your Flex payment method.'
        },
        {
            HEADER: 'Rent payment',
            BODY: 'Use your Flex payment method to pay rent in your rent portal.'
        },
        {
            HEADER: '2nd payment',
            BODY: 'We’ll automatically process your 2nd payment on the date you selected.'
        },
    ],
    DDA_BULLETS: [
        {
            HEADER: 'Get ready',
            BODY: 'When you’re ready to pay your rent, confirm the amount of your rent bill in the Flex app.'
        },
        {
            HEADER: '1st payment',
            BODY: 'Make your 1st payment to activate your Flex bank account.'
        },
        {
            HEADER: 'Rent payment',
            BODY: 'Use your Flex bank account to pay rent in your rent portal.'
        },
        {
            HEADER: '2nd payment',
            BODY: 'We’ll automatically process your 2nd payment on the date you selected.'
        },
    ],
    VIRTUAL_CARD_BULLETS: [
        {
            HEADER: 'Get ready',
            BODY: 'When you’re ready to pay your rent, confirm the amount of your rent bill in the Flex app.'
        },
        {
            HEADER: '1st payment',
            BODY: 'Make your 1st payment to activate your Flex virtual card.'
        },
        {
            HEADER: 'Rent payment',
            BODY: 'Use your Flex virtual card to pay rent in your rent portal.'
        },
        {
            HEADER: '2nd payment',
            BODY: 'We’ll automatically process your 2nd payment on the date you selected.'
        },
    ],
    SLC_BULLETS: [
        {
            HEADER: 'Make your deposit',
            BODY: 'Activate your credit line with your deposit. You’ll get it back when you stop using Flex.'
        },
        {
            HEADER: 'Rent payment',
            BODY: 'Confirm your rent amount in the app and use your Flex-provided debit card to pay rent in your rent portal.'
        },
        {
            HEADER: 'Pay Flex back',
            BODY: 'We’ll automatically process your 2 payments on the scheduled dates'
        },
        {
            HEADER: '',
            BODY: ''
        },
    ],
    SIMPLIFIED_PAYMENTS_BULLETS: [
        {
            HEADER: 'Get ready',
            BODY: 'Confirm your rent amount in the app and activate your credit line by making your deposit.'
        },
        {
            HEADER: 'Rent payment',
            BODY: 'Use your Flex-provided debit card to pay rent in your rent portal.'
        },
        {
            HEADER: 'Pay Flex back',
            BODY: 'We’ll automatically process your scheduled payment on the day you selected and use your deposit to pay the rest.'
        },
        {
            HEADER: 'Repeat each month!',
            BODY: ''
        },
    ],
    SELF_PAY_BULLETS: [
        {
            HEADER: 'Enter your rent bill amount',
            BODY: 'Open the Flex app when rent is due. Tell us your rent amount for the month to kick off the process.'
        },
        {
            HEADER: 'Make 1st payment',
            BODY: 'After you make your 1st payment, your full rent amount will be available in a Flex bank account.'
        },
        {
            HEADER: 'Submit your rent to your property',
            BODY: "Use the Flex {{paymentMethod}} to submit rent through your property's portal before the 5th (or before rent is due)."
        },
        {
            HEADER: 'Pay Flex back',
            BODY: 'We’ll automatically process your 2nd payment on the date you chose.'
        },
    ]
};
